import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent
} from "@mui/material";
import { useState } from "react";
import PaperDraggable from "../../../../../../components/PaperDraggable";
import { TFiltroListarSolicitacao } from "..";

export default function DialogListarSolicitacao({
  open,
  filtrosAtuais,
  onClose,
  onConfirm
}: DialogListarSolicitacaoProps) {
  const [selectedStatus, setSelectedStatus] = useState<string | null>(
    filtrosAtuais.status && filtrosAtuais.status.length > 0 ? filtrosAtuais.status[0] : ''
  );

  const handleStatusChange = (event: SelectChangeEvent<string>) => {
    setSelectedStatus(event.target.value);
  };

  const handleConfirm = () => {
    const novosFiltros: TFiltroListarSolicitacao = {
      ...filtrosAtuais,
      status: selectedStatus ? [selectedStatus] : undefined
    };

    onConfirm(novosFiltros);
    onClose();
  };

  const handleClear = () => {
    setSelectedStatus('');
    const { status, ...outrosFiltros } = filtrosAtuais;
    onConfirm(outrosFiltros);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperComponent={PaperDraggable}
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        Filtros
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid size={{ xs: 12 }}>
            <FormControl fullWidth>
              <InputLabel id="status-solicitacao-select-label">Status</InputLabel>
              <Select
                labelId="status-solicitacao-select-label"
                id="status-solicitacao-select"
                value={selectedStatus || ''}
                label="Status"
                onChange={handleStatusChange}
              >
                <MenuItem value=""><em>Selecione um status</em></MenuItem>
                <MenuItem value="Em aberto">Em aberto</MenuItem>
                <MenuItem value="Em andamento">Em andamento</MenuItem>
                <MenuItem value="Finalizado">Finalizado</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClear}>Limpar</Button>
        <Button variant="contained" onClick={handleConfirm}>
          Aplicar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

interface DialogListarSolicitacaoProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (filters: TFiltroListarSolicitacao) => void;
  filtrosAtuais: TFiltroListarSolicitacao;
}